import React from 'react';
import {Button, Switch, DatePicker, Spin} from 'antd';
import { connect } from 'react-redux';
import TableView from '../tableView';
import UseRequestBlock from '../../Hooks/UseRequestBlock';
import moment from "moment";
import { CheckOutlined, CloseOutlined } from '@ant-design/icons';
const { RangePicker } = DatePicker;

function RequestBlock(props) {
    const [requestBlock, actions, updateRequestBlockState, generateRequests] = UseRequestBlock();
    const { data, startDate, endDate, googleDrive, isTableLoading  } = requestBlock;

    const changeDatesRange = (dates, dateStrings) => {
        updateRequestBlockState({ startDate: dateStrings[0], endDate: dateStrings[1] });
    }

    const handleChangeGoogleDrive = (googleDrive) => {
        updateRequestBlockState({ googleDrive });
    }
    const { email } = props.drive;
    return (
        <>
            <p className="label">En esta opción con una sola solicitud podrás hacer múltiples solicitudes de descarga para varios RFCs en un rango de fechas y poder cargar tu histórico de CFDIs de una manera sencilla.</p>
            <div className="flex-container-between " style={{marginBottom: '25px'}}>
                <div className="filters-container" style={{justifyContent: 'flex-start'}}>
                    <div className="input-container" style={{width: '100%'}}>
                        <label htmlFor="" className="label block">Seleccionar Rango de fecha:</label>
                        <RangePicker
                            value={(startDate === '' || endDate === '' ? '' : [moment(startDate, 'MM-DD-YYYY'), moment(endDate, 'MM-DD-YYYY')])}
                            style={{ width: '100%', maxWidth: 460 }}
                            format="MM-DD-YYYY"
                            onChange={changeDatesRange}
                        />
                    </div>                    
                </div>
                <div className="actions-container" style={{width: '100%', display:'flex', justifyContent: 'flex-end'}}>
                    <div className="input-container-inline" style={{ display: 'flex', alignItems: 'center', margin: '0' }}>
                        <Switch
                            onChange={handleChangeGoogleDrive}
                            checkedChildren={<CheckOutlined />}
                            unCheckedChildren={<CloseOutlined />}
                            checked={googleDrive}
                            disabled={email === ''}
                            style={{ width: '50px', margin: 'auto' }}
                        />
                        <label htmlFor="" className="label block" style={{marginLeft:'5px'}}>Google Drive</label>
                    </div>
                    <Button type="primary" onClick={()=>{generateRequests()}}>Generar solicitudes</Button>
                </div>
            </div>
            <TableView disablePagination={false} className='width500' loading={false} columns={actions()} data={data} />
            {isTableLoading &&
                <div className="loading-container loading-absolute">
                    <Spin size="large" tip="Cargando" />
                </div>
            }
        </>
    )
}
const mapStateToProps = state => {	
	return {		
		drive: state.googleDrive.data,		
	};
};
export default connect(mapStateToProps,null)(RequestBlock);